export const documentStatusConstants = {
  APPROVED: 0,
  REJECTED: 1,
  PENDING: 2,
};
